<div [class]="columnClass()">
  <label class="form-label">{{ fromLabel() }}</label>
  <kendo-datepicker class="w-100" [attr.data-testid]="testId() ? testId() + '-from' : null" [value]="from()"
    (valueChange)="onFromChange($event)">
  </kendo-datepicker>
</div>

<div [class]="columnClass()">
  <label class="form-label">{{ toLabel() }}</label>
  <kendo-datepicker class="w-100" [attr.data-testid]="testId() ? testId() + '-to' : null" [value]="to()"
    (valueChange)="onToChange($event)">
  </kendo-datepicker>
</div>
